/* eslint-disable camelcase */
import axios from 'axios';
import i18next from 'i18next';
import {
  appResourceHubUrl,
  envId,
  tenantId,
  applicationId
} from '../settings.json';

class TranslationService {
  moduleT = module => (key, options) => i18next.t(`${module}.${key}`, options);

  fetchTranslations = async (locale = 'en-US') => {
    const headers = {
      'content-type': 'application/json',
      'x-tenant-id': tenantId
    };

    const url = `${appResourceHubUrl}/translations/environments/${window.REACT_APP_ENV_ID ||
      envId}/applications/${applicationId}/locales/${locale}`;

    const translations = await axios.create()({
      method: 'get',
      url,
      headers
    });

    const applicationPartTranslations = Object.entries(
      translations.data.applicationPartTranslations
    ).reduce(
      (acc, [configId, configData]) => {
        acc[locale][configId] = configData.translation;
        return acc;
      },
      { [locale]: {} }
    );

    const data = {
      ...translations.globalTranslations,
      ...applicationPartTranslations[locale]
    };
    return { data };
  };

  fetchLanguages = async () => {
    // const headers = {
    //   'content-type': 'application/json'
    // };

    // const url = `${appResourceHubUrl}/translations/environments/${window.REACT_APP_ENV_ID ||
    //   envId}/applications/${applicationId}/locales`;

    try {
      // const data = await axios.create()({
      //   method: "get",
      //   url,
      //   headers,
      // });
      const data = {
        data: {
          es: {
            name: 'Spanish'
          },
          af: {
            name: 'Afrikaans'
          },
          'en-US': {
            name: 'English'
          },
          de: {
            name: 'German'
          },
          el: {
            name: 'Greek'
          }
        }
      };
      return data;
    } catch (err) {
      return console.log('Error in translation service:', err);
    }
  };
}

const inst = new TranslationService();
export default inst;
